import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper } from "@mui/material"
import Draggable from "react-draggable";


function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const Popupdialog = ({ oncancel, onsuccess, toptext, question, successtext }) => {

    return (
        <Dialog
            open={true}
            onClose={() => oncancel()}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                {toptext}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {question}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={() => oncancel()}>
                    Cancel
                </Button>
                <Button onClick={() => onsuccess()}>{successtext}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default Popupdialog